import { POST } from './api';

import LocalStorageService from './localStorageService';

// Authentication State Checks
export const isLoggedIn = async () => {
    const token = localStorage.getItem('token');
    return !!token;
};

// Auth Secret
export const setAuthSecret = async (secret) => {
    return localStorage.setItem('authSecret', secret);
};

export const getAuthSecret = async () => {
    return localStorage.getItem('authSecret');
};

export const removeAuthSecret = async () => {
    return LocalStorageService.removeItem('authSecret');
};

// Auth Email
export const setAuthEmail = async (email) => {
    return localStorage.setItem('authEmail', email);
};

export const getAuthEmail = async () => {
    return localStorage.getItem('authEmail');
};

export const removeAuthEmail = async () => {
    // return LocalStorageService.removeItem('authEmail');
};

// Auth Token
export const setAuthToken = async (token) => {
    return localStorage.setItem('token', token);
};

export const getAuthToken = async () => {
    return localStorage.getItem('token');
};

export const removeAuthToken = async () => {
    // return LocalStorageService.removeItem('token');
};

// Auth User ID
export const setAuthUserId = async (userId) => {
    return localStorage.setItem('authUserId', userId);
};

export const getAuthUserId = async () => {
    return localStorage.getItem('authUserId');
};

export const removeAuthUserId = async () => {
    return LocalStorageService.removeItem('authUserId');
};

// Login APIs
export const loginRequestPin = async (email) => {
    const response = await POST('/sheffmed-auth/start', { email });
    console.log("loginRequestPin", response);
    return response;
};

export const loginConfirmPin = async (email, pin, secret) => {
    console.log("loginConfirmPin", email, pin, secret);

    const response = await POST('/sheffmed-auth/complete', {
        email,
        pin,
        secret
    });
    return response;
};